import React, { useCallback } from "react";
import _ from "lodash";
import { useSelector } from 'react-redux'
import EmployeeList, { EmployeeListModes } from 'components/organisms/EmployeeList'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation } from '@react-navigation/native'
import i18n from "utils/i18n";
import { dataConstants } from 'services/redux/data/constants'
import LoadingComponent from 'components/atoms/Loading'
import selectEmployeeEros from 'services/redux/data/selectors/selectEmployeeEros'

const EroTab = () => {
	const navigation = useNavigation();
	
	const _eros = useSelector( selectEmployeeEros );
	const _erosLoaded = useSelector( state => {
		return state.data[dataConstants.EMPLOYEES_ERO_LOADED];
	} );
	
	const openEro = useCallback(
		( employee ) => {
			navigation.navigate( AppRoutes.ERO_COWORKER, {
				employee: employee.guid,
			} );
		},
		[ _eros ]
	);
	
	const sortedEros = _.sortBy( _eros, ( ero ) => {
		return _.size( _.get( ero, 'scans', [] ) ) > 0 ? 0 : 1;
	});
	
	if( _erosLoaded === false ){
		return <LoadingComponent size={'m'} />;
	}
	
	return (
		<EmployeeList
			employees={ sortedEros }
			mode={ EmployeeListModes.ERO }
			onPress={ openEro }
			showDetails={ true }
			noResultText={ i18n.t( 'pages.coworker_eros.no_eros') }
		/>
	);
}

export default EroTab
